import { useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";

const PermitListItem = ({ permit, handleInputChange }) => {
  const [checked, setChecked] = useState(false);

  const [text, setText] = useState("");

  const handleCheck = (e) => {
    setChecked(e.target.checked);
    if (!e.target.checked) {
      setText("");
      handleInputChange({target: {
        name: 'jobPermit',
        value: { [permit.id]: "" }}});
    }
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
    handleInputChange({target: {
        name: 'jobPermit',
        value: { [permit.id]: e.target.value }}});
  };

  return (
    <li key={`${permit.id}_${permit.name}`} style={{ display: "flex" }}>
      <FormControlLabel
        className="permit_check"
        control={
          <Checkbox
            value={permit.id}
            checked={checked}
            onChange={handleCheck}
            key={`${permit.id}_${permit.name}`}
          />
        }
        label={permit.name}
        key={`${permit.id}_${permit.name}`}
      />
      <TextField
        size="small"
        label=""
        variant="outlined"
        name={permit.id}
        sx={{ marginLeft: "auto" }}
        placeholder="Permit No"
        value={text}
        onChange={handleTextChange}
        disabled={!checked}
      />
    </li>
  );
};

export default PermitListItem;
